import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const getHomeByRole = (role) => {
  if (role === 2) return "/school";
  if (role === 3) return "/faculty";
  if (role === 1 || role === 4) return "/admin";
  return "/";
};

export default function RoleGuard({ allowedRoles = [], children }) {
  const user = useSelector((state) => state.auth.user);
  const authChecked = useSelector((state) => state.auth.authChecked);
  const role = user?.role;
  const location = useLocation();

  // Auth is restored asynchronously on a full page load (loadUser → /me). Until
  // that settles, DON'T bounce — otherwise refreshing or deep-linking any guarded
  // route (e.g. the schools detail page) kicks the user back to "/".
  if (!authChecked) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh", color: "#64748b", fontSize: 15 }}>
        Loading…
      </div>
    );
  }

  if (!role) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={getHomeByRole(role)} replace state={{ from: location }} />;
  }

  return children;
}

